import { auth, handleSession } from '@/api/Auth';
import { proposalStore } from '@/store/app';

export async function authenticate() {
  const data = await auth();
  if (!data) {
    return clearSession();
  }
  localStorage.setItem('pravaler_token', data);
}

export function logged(): boolean {
  const token = localStorage.getItem('pravaler_token');
  return ![null, undefined, '', 'null'].includes(token);
}

function clearSession() {
  localStorage.removeItem('pravaler_token');
}

export async function handleStudentSession(cpf) {
  const { token, simulation_id } = await handleSession({ cpf, simulation_id: proposalStore().getProposal().simulation_id });
  if (token !== localStorage.getItem('pravaler_token')) {
    localStorage.setItem('pravaler_token', token);
    proposalStore().reset();
    proposalStore().setSimulationId(simulation_id);
  }
}
